(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar {
    constructor(element) {
      this.element = element;
      this.messages = Array.from(element.querySelectorAll('.announcement-bar__message'));
      this.currentIndex = 0;
      this.totalMessages = this.messages.length;
      this.autoplayEnabled = element.dataset.autoplay === 'true';
      this.rotationSpeed = this.clampSpeed(parseInt(element.dataset.speed) || 5);
      this.intervalId = null;
      
      this.prevButton = element.querySelector('.announcement-bar__arrow--prev');
      this.nextButton = element.querySelector('.announcement-bar__arrow--next');
      
      this.init();
    }

    clampSpeed(speed) {
      return Math.max(2, Math.min(30, speed));
    }

    init() {
      // Hide bar if no messages
      if (this.totalMessages === 0) {
        this.element.style.display = 'none';
        return;
      }

      // Show navigation arrows if multiple messages and arrows are enabled
      const showArrows = this.element.dataset.showArrows === 'true';
      if (this.totalMessages > 1 && showArrows) {
        this.element.classList.add('announcement-bar--has-multiple');
        
        // Add event listeners
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.prevMessage());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.nextMessage());
        }
      }
      
      // Start autoplay if enabled and multiple messages
      if (this.autoplayEnabled && this.totalMessages > 1) {
        this.startAutoplay();
      }
    }

    destroy() {
      this.stopAutoplay();
      if (this.prevButton) {
        this.prevButton.removeEventListener('click', () => this.prevMessage());
      }
      if (this.nextButton) {
        this.nextButton.removeEventListener('click', () => this.nextMessage());
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.intervalId = setInterval(() => {
        this.nextMessage();
      }, this.rotationSpeed * 1000);
    }

    stopAutoplay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    resetAutoplay() {
      if (this.autoplayEnabled && this.totalMessages > 1) {
        this.startAutoplay();
      }
    }

    showMessage(index) {
      // Remove active class from all messages
      this.messages.forEach(msg => {
        msg.classList.remove('announcement-bar__message--active');
      });
      
      // Add active class to current message
      if (this.messages[index]) {
        this.messages[index].classList.add('announcement-bar__message--active');
      }
      
      this.currentIndex = index;
    }

    nextMessage() {
      const nextIndex = (this.currentIndex + 1) % this.totalMessages;
      this.showMessage(nextIndex);
      this.resetAutoplay();
    }

    prevMessage() {
      const prevIndex = (this.currentIndex - 1 + this.totalMessages) % this.totalMessages;
      this.showMessage(prevIndex);
      this.resetAutoplay();
    }
  }

  // Initialize announcement bar
  let announcementBarInstance = null;

  document.addEventListener('DOMContentLoaded', () => {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBarInstance = new AnnouncementBar(announcementBar);
    }
  });

  // Cleanup on section unload (for theme editor)
  document.addEventListener('shopify:section:unload', () => {
    if (announcementBarInstance) {
      announcementBarInstance.destroy();
      announcementBarInstance = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterToggle = document.getElementById('filter-toggle');
    const filterClose = document.getElementById('filter-close');
    const filters = document.getElementById('collection-filters');
    const clearFilters = document.getElementById('clear-filters');
    const productGrid = document.getElementById('product-grid');
    const noResults = document.getElementById('no-results');
    const sortSelect = document.getElementById('sort-by');
    const clearTagSelection = document.getElementById('clear-tag-selection');
    const visibleCountEl = document.getElementById('visible-count');
    const totalCountEl = document.getElementById('total-count');
    const loadingIndicator = document.getElementById('loading-indicator');

    const collectionHandle = window.__collectionHandle;
    const totalProducts = window.__collectionProductCount;

    // All products data store
    let allProducts = [];
    let allSizes = new Set();
    let allColors = new Set();

    // Create overlay for mobile
    const overlay = document.createElement('div');
    overlay.className = 'collection-filters-overlay';
    document.body.appendChild(overlay);

    // Get all tag navigation buttons
    const tagButtons = document.querySelectorAll('.tag-nav__item');

    // Active filters object
    let activeFilters = {
      size: [],
      price: [],
      availability: [],
      type: [],
      vendor: [],
      color: []
    };

    // Active tags array
    let activeTags = [];

    // ============================================================
    // AJAX PRODUCT LOADING - Fetches ALL products in batches of 50
    // ============================================================
    async function fetchAllProducts() {
      const perPage = 50;
      const totalPages = Math.ceil(totalProducts / perPage);
      let loadedCount = 0;
      const progressBar = document.getElementById('load-progress-bar');
      const progressWrap = document.getElementById('load-progress');

      for (let page = 1; page <= totalPages; page++) {
        try {
          const url = '/collections/' + collectionHandle + '/products.json?limit=' + perPage + '&page=' + page;
          const response = await fetch(url);
          if (!response.ok) break;
          
          const data = await response.json();
          if (!data.products || data.products.length === 0) break;

          const batchProducts = [];

          data.products.forEach(function(product, idx) {
            let productSizes = [];
            let productColors = [];
            
            if (product.options) {
              product.options.forEach(function(option) {
                const optName = option.name.toLowerCase();
                if (optName === 'size') {
                  option.values.forEach(function(v) {
                    productSizes.push(v);
                    allSizes.add(v);
                  });
                }
                if (optName === 'color' || optName === 'colour') {
                  option.values.forEach(function(v) {
                    productColors.push(v);
                    allColors.add(v);
                  });
                }
              });
            }

            let available = false;
            if (product.variants) {
              available = product.variants.some(function(v) { return v.available; });
            }

            let price = 0;
            let compareAtPrice = 0;
            if (product.variants && product.variants.length > 0) {
              price = parseFloat(product.variants[0].price) * 100;
              if (product.variants[0].compare_at_price) {
                compareAtPrice = parseFloat(product.variants[0].compare_at_price) * 100;
              }
            }

            let tagHandles = [];
            if (product.tags) {
              const tagsStr = typeof product.tags === 'string' ? product.tags : product.tags.join(', ');
              tagHandles = tagsStr.split(',').map(function(t) { 
                return t.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); 
              }).filter(function(t) { return t !== ''; });
            }

            function toHandle(str) {
              return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            }

            const productData = {
              id: product.id,
              title: product.title,
              handle: product.handle,
              url: '/products/' + product.handle,
              price: price,
              compareAtPrice: compareAtPrice,
              available: available,
              type: toHandle(product.product_type || ''),
              vendor: toHandle(product.vendor || ''),
              sizes: productSizes.map(function(s) { return toHandle(s); }),
              colors: productColors.map(function(c) { return toHandle(c); }),
              tags: tagHandles,
              image: product.images && product.images.length > 0 ? product.images[0].src : null,
              createdAt: product.created_at ? new Date(product.created_at).getTime() / 1000 : 0,
              position: loadedCount + idx
            };

            allProducts.push(productData);
            batchProducts.push(productData);
          });

          loadedCount += data.products.length;

          // Render this batch immediately
          renderBatch(batchProducts);

          // Apply current filters to newly added cards
          if (hasActiveFilters()) {
            applyFilters();
          }

          // Update counts
          if (totalCountEl) totalCountEl.textContent = loadedCount;
          if (visibleCountEl && !hasActiveFilters()) visibleCountEl.textContent = loadedCount;

          // Update progress bar
          if (progressBar) {
            const pct = Math.min(100, Math.round((loadedCount / totalProducts) * 100));
            progressBar.style.width = pct + '%';
          }

        } catch (e) {
          console.error('Error fetching products page ' + page, e);
          break;
        }
      }

      // Done loading — hide progress
      if (loadingIndicator) loadingIndicator.style.display = 'none';
      if (progressWrap) {
        progressBar.style.width = '100%';
        setTimeout(function() { progressWrap.style.display = 'none'; }, 500);
      }
      
      // Build dynamic filter options (sizes, colors)
      buildDynamicFilters();
      
      // Bind filter checkboxes (including newly created ones)
      bindFilterCheckboxes();

      // Re-apply filters one final time
      applyFilters();

      // Apply sort if URL has sort parameter
      if (sortSelect) {
        const urlParams = new URLSearchParams(window.location.search);
        const urlSort = urlParams.get('sort_by');
        if (urlSort && urlSort !== 'best-selling') {
          sortSelect.dispatchEvent(new Event('change'));
        }
      }
    }

    function hasActiveFilters() {
      if (activeTags.length > 0) return true;
      for (let key in activeFilters) {
        if (activeFilters[key].length > 0) return true;
      }
      return false;
    }

    // Render a single batch of products (appends to grid)
    function renderBatch(products) {
      if (!productGrid) return;

      products.forEach(function(product, index) {
        const card = document.createElement('div');
        card.className = 'product-card';
        card.setAttribute('data-product-id', product.id);
        card.setAttribute('data-price', product.price);
        card.setAttribute('data-available', product.available);
        card.setAttribute('data-type', product.type);
        card.setAttribute('data-vendor', product.vendor);
        card.setAttribute('data-sizes', product.sizes.join(','));
        card.setAttribute('data-colors', product.colors.join(','));
        card.setAttribute('data-tags', product.tags.join(','));
        card.setAttribute('data-title', product.title);
        card.setAttribute('data-created', Math.floor(product.createdAt));
        card.setAttribute('data-position', product.position);

        const priceInRupees = product.price / 100;
        const compareInRupees = product.compareAtPrice / 100;

        let badgeHTML = '';
        if (!product.available) {
          badgeHTML = '<span class="product-card__badge product-card__badge--sold-out">Sold out</span>';
        } else if (product.compareAtPrice > product.price && product.compareAtPrice > 0) {
          const discount = Math.round((product.compareAtPrice - product.price) / product.compareAtPrice * 100);
          badgeHTML = '<span class="product-card__badge product-card__badge--sale">-' + discount + '%</span>';
        }

        let priceHTML = '';
        if (product.compareAtPrice > product.price && product.compareAtPrice > 0) {
          priceHTML = '<span class="product-card__price-sale">₹' + formatMoney(priceInRupees) + '</span>' +
                      '<span class="product-card__price-compare">₹' + formatMoney(compareInRupees) + '</span>';
        } else {
          priceHTML = '<span class="product-card__price-regular">₹' + formatMoney(priceInRupees) + '</span>';
        }

        let imageHTML = '';
        if (product.image) {
          imageHTML = '<img src="' + product.image + '" alt="' + escapeHTML(product.title) + '" width="600" height="600" loading="lazy" class="product-card__image">';
        } else {
          imageHTML = '<div class="product-card__no-image"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg></div>';
        }

        card.innerHTML = '<a href="' + product.url + '" class="product-card__link">' +
          '<div class="product-card__image-wrapper">' +
            imageHTML +
            '<div class="product-card__badges">' + badgeHTML + '</div>' +
          '</div>' +
          '<div class="product-card__info">' +
            '<h3 class="product-card__title">' + escapeHTML(product.title) + '</h3>' +
            '<div class="product-card__price">' + priceHTML + '</div>' +
          '</div>' +
        '</a>';

        productGrid.appendChild(card);
      });
    }

    function formatMoney(amount) {
      return amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    function escapeHTML(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function buildDynamicFilters() {
      // Size filters
      if (allSizes.size > 0) {
        const sizeGroup = document.getElementById('size-filter-group');
        const sizeOptions = document.getElementById('size-filter-options');
        if (sizeGroup && sizeOptions) {
          sizeGroup.style.display = '';
          const sortedSizes = Array.from(allSizes).sort();
          sortedSizes.forEach(function(size) {
            if (!size || size.trim() === '') return;
            const handle = size.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            const label = document.createElement('label');
            label.className = 'filter-option';
            label.innerHTML = '<input type="checkbox" name="size" value="' + handle + '" data-filter-type="size" data-original-value="' + size.replace(/"/g, '&quot;') + '"><span>' + size + '</span>';
            sizeOptions.appendChild(label);
          });
        }
      }

      // Color filters
      if (allColors.size > 0) {
        const colorGroup = document.getElementById('color-filter-group');
        const colorOptions = document.getElementById('color-filter-options');
        if (colorGroup && colorOptions) {
          colorGroup.style.display = '';
          const sortedColors = Array.from(allColors).sort();
          sortedColors.forEach(function(color) {
            if (!color || color.trim() === '') return;
            const handle = color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            const label = document.createElement('label');
            label.className = 'filter-option';
            label.innerHTML = '<input type="checkbox" name="color" value="' + handle + '" data-filter-type="color" data-original-value="' + color.replace(/"/g, '&quot;') + '"><span>' + color + '</span>';
            colorOptions.appendChild(label);
          });
        }
      }
    }

    // ============================================================
    // FILTER & SORT LOGIC (same as before)
    // ============================================================

    // Toggle filter sidebar
    if (filterToggle) {
      filterToggle.addEventListener('click', function() {
        filters.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeFilters() {
      if (filters) {
        filters.classList.remove('active');
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    if (filterClose) {
      filterClose.addEventListener('click', closeFilters);
    }

    overlay.addEventListener('click', closeFilters);

    // Clear all filters
    if (clearFilters) {
      clearFilters.addEventListener('click', function() {
        const allCheckboxes = filters.querySelectorAll('input[type="checkbox"]');
        allCheckboxes.forEach(function(cb) { cb.checked = false; });
        for (let key in activeFilters) {
          activeFilters[key] = [];
        }
        applyFilters();
      });
    }

    // Handle tag button clicks
    tagButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const tag = this.getAttribute('data-tag');
        
        if (this.classList.contains('tag-nav__item--active')) {
          this.classList.remove('tag-nav__item--active');
          const index = activeTags.indexOf(tag);
          if (index > -1) activeTags.splice(index, 1);
        } else {
          this.classList.add('tag-nav__item--active');
          if (!activeTags.includes(tag)) activeTags.push(tag);
        }
        
        updateClearButtonVisibility();
        applyFilters();
      });
    });

    // Clear tag selection
    if (clearTagSelection) {
      clearTagSelection.addEventListener('click', function() {
        activeTags = [];
        tagButtons.forEach(function(button) {
          button.classList.remove('tag-nav__item--active');
        });
        updateClearButtonVisibility();
        applyFilters();
      });
    }

    function updateClearButtonVisibility() {
      if (clearTagSelection) {
        clearTagSelection.style.display = activeTags.length > 0 ? 'flex' : 'none';
      }
    }

    // Bind filter checkbox events (called after dynamic filters are built)
    function bindFilterCheckboxes() {
      const allCheckboxes = filters.querySelectorAll('input[type="checkbox"]');
      allCheckboxes.forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
          const filterType = this.getAttribute('data-filter-type');
          const filterValue = this.value;
          
          if (this.checked) {
            if (!activeFilters[filterType].includes(filterValue)) {
              activeFilters[filterType].push(filterValue);
            }
          } else {
            const index = activeFilters[filterType].indexOf(filterValue);
            if (index > -1) activeFilters[filterType].splice(index, 1);
          }
          
          applyFilters();
        });
      });
    }

    // Apply filters function
    function applyFilters() {
      const productCards = productGrid.querySelectorAll('.product-card');
      let visibleCount = 0;

      productCards.forEach(function(card) {
        let shouldShow = true;

        // Check tag filter
        if (activeTags.length > 0) {
          const productTagsRaw = card.getAttribute('data-tags') || '';
          const productTags = productTagsRaw.toLowerCase().split(',').map(function(t) { return t.trim(); }).filter(function(t) { return t !== ''; });
          const hasMatchingTag = activeTags.some(function(tag) {
            return productTags.includes(tag.toLowerCase().trim());
          });
          if (!hasMatchingTag) shouldShow = false;
        }

        // Check size filter
        if (activeFilters.size.length > 0 && shouldShow) {
          const productSizes = (card.getAttribute('data-sizes') || '').toLowerCase().split(',').filter(function(s) { return s !== ''; });
          const hasMatchingSize = activeFilters.size.some(function(size) {
            return productSizes.some(function(pSize) {
              return pSize === size.toLowerCase() || pSize.includes(size.toLowerCase());
            });
          });
          if (!hasMatchingSize) shouldShow = false;
        }

        // Check price filter
        if (activeFilters.price.length > 0 && shouldShow) {
          const productPrice = parseFloat(card.getAttribute('data-price')) / 100;
          let matchesPrice = false;

          activeFilters.price.forEach(function(priceRange) {
            const parts = priceRange.split('-');
            const min = parts[0];
            const max = parts[1];
            if (max === 'plus') {
              if (productPrice >= parseInt(min)) matchesPrice = true;
            } else {
              if (productPrice >= parseInt(min) && productPrice < parseInt(max)) matchesPrice = true;
            }
          });

          if (!matchesPrice) shouldShow = false;
        }

        // Check availability filter
        if (activeFilters.availability.length > 0 && shouldShow) {
          const isAvailable = card.getAttribute('data-available') === 'true';
          let matchesAvailability = false;

          activeFilters.availability.forEach(function(avail) {
            if (avail === 'in-stock' && isAvailable) matchesAvailability = true;
            if (avail === 'out-of-stock' && !isAvailable) matchesAvailability = true;
          });

          if (!matchesAvailability) shouldShow = false;
        }

        // Check product type filter
        if (activeFilters.type.length > 0 && shouldShow) {
          const productType = card.getAttribute('data-type');
          if (!activeFilters.type.includes(productType)) shouldShow = false;
        }

        // Check vendor filter
        if (activeFilters.vendor.length > 0 && shouldShow) {
          const productVendor = card.getAttribute('data-vendor');
          if (!activeFilters.vendor.includes(productVendor)) shouldShow = false;
        }

        // Check color filter
        if (activeFilters.color.length > 0 && shouldShow) {
          const productColors = (card.getAttribute('data-colors') || '').toLowerCase().split(',').filter(function(c) { return c !== ''; });
          const hasMatchingColor = activeFilters.color.some(function(color) {
            return productColors.some(function(pColor) {
              return pColor === color.toLowerCase() || pColor.includes(color.toLowerCase());
            });
          });
          if (!hasMatchingColor) shouldShow = false;
        }

        if (shouldShow) {
          card.classList.remove('filtered-out');
          visibleCount++;
        } else {
          card.classList.add('filtered-out');
        }
      });

      if (visibleCountEl) visibleCountEl.textContent = visibleCount;
      noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    // Handle sorting
    if (sortSelect) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlSort = urlParams.get('sort_by');
      if (urlSort && sortSelect.querySelector('option[value="' + urlSort + '"]')) {
        sortSelect.value = urlSort;
      }

      sortSelect.addEventListener('change', function() {
        const sortValue = this.value;
        const cards = Array.from(productGrid.querySelectorAll('.product-card'));
        
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortValue);
        window.history.replaceState({}, '', url);
        
        cards.sort(function(a, b) {
          switch(sortValue) {
            case 'price-ascending':
              return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
            case 'price-descending':
              return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
            case 'title-ascending':
              return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
            case 'title-descending':
              return (b.getAttribute('data-title') || '').localeCompare(a.getAttribute('data-title') || '');
            case 'created-ascending':
              return parseInt(a.getAttribute('data-created') || 0) - parseInt(b.getAttribute('data-created') || 0);
            case 'created-descending':
              return parseInt(b.getAttribute('data-created') || 0) - parseInt(a.getAttribute('data-created') || 0);
            case 'best-selling':
            default:
              return parseInt(a.getAttribute('data-position') || 0) - parseInt(b.getAttribute('data-position') || 0);
          }
        });

        cards.forEach(function(card) { productGrid.appendChild(card); });
      });

    }

    // ============================================================
    // START LOADING ALL PRODUCTS
    // ============================================================
    fetchAllProducts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-bar"] && !Shopify.designMode) return;
  try {
    
  class FeaturesBar {
    constructor(element) {
      this.element = element;
      this.items = Array.from(element.querySelectorAll('.features-bar__item'));
      this.currentIndex = 0;
      this.intervalId = null;
      this.isMobile = window.innerWidth <= 768;
      
      this.init();
      this.handleResize();
    }

    init() {
      if (this.isMobile && this.items.length > 0) {
        // Show first item on mobile
        this.items[0].classList.add('features-bar__item--active');
        
        // Start auto-rotation if multiple items
        if (this.items.length > 1) {
          this.startAutoRotation();
        }
      }
    }

    handleResize() {
      window.addEventListener('resize', () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 768;
        
        if (wasMobile !== this.isMobile) {
          if (this.isMobile) {
            this.init();
          } else {
            this.stopAutoRotation();
            this.items.forEach(item => item.classList.remove('features-bar__item--active'));
          }
        }
      });
    }

    startAutoRotation() {
      this.stopAutoRotation();
      this.intervalId = setInterval(() => {
        this.nextItem();
      }, 3000); // Rotate every 3 seconds
    }

    stopAutoRotation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    nextItem() {
      // Remove active class from current item
      this.items[this.currentIndex].classList.remove('features-bar__item--active');
      
      // Move to next item
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      
      // Add active class to new item
      this.items[this.currentIndex].classList.add('features-bar__item--active');
    }

    destroy() {
      this.stopAutoRotation();
    }
  }

  // Initialize features bar
  document.addEventListener('DOMContentLoaded', () => {
    const featuresBar = document.querySelector('.features-bar');
    if (featuresBar) {
      new FeaturesBar(featuresBar);
    }
  });

  // Cleanup on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('.features-bar')) {
      const featuresBar = event.target.querySelector('.features-bar');
      if (featuresBar && featuresBar.featuresBarInstance) {
        featuresBar.featuresBarInstance.destroy();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Search functionality
  const searchIcon = document.querySelector('.header__icon--search');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('search-input');
  const searchContent = document.getElementById('search-content');
  const searchLoading = document.getElementById('search-loading');
  const searchEmpty = document.getElementById('search-empty');
  const searchForm = document.querySelector('.search-form');

  let searchTimeout;
  let currentRequest;

  // Open search overlay
  if (searchIcon) {
    searchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      searchOverlay.classList.add('search-overlay--active');
      setTimeout(() => {
        searchInput.focus();
      }, 300);
    });
  }

  // Live search functionality
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const query = this.value.trim();
      
      clearTimeout(searchTimeout);
      
      if (currentRequest) {
        currentRequest.abort();
      }

      if (query.length < 2) {
        hideAllResults();
        return;
      }

      showLoading();

      searchTimeout = setTimeout(() => {
        performSearch(query);
      }, 300);
    });

    searchForm.addEventListener('submit', function(e) {
      const query = searchInput.value.trim();
      if (query.length > 0) {
        return;
      }
      e.preventDefault();
    });
  }

  // Close search overlay
  if (searchClose) {
    searchClose.addEventListener('click', function() {
      closeSearch();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('search-overlay--active')) {
      closeSearch();
    }
  });

  searchOverlay.addEventListener('click', function(e) {
    if (e.target === searchOverlay) {
      closeSearch();
    }
  });

  function closeSearch() {
    searchOverlay.classList.remove('search-overlay--active');
    searchInput.value = '';
    hideAllResults();
    if (currentRequest) {
      currentRequest.abort();
    }
  }

  function showLoading() {
    searchLoading.style.display = 'flex';
    searchContent.style.display = 'none';
    searchEmpty.style.display = 'none';
  }

  function hideAllResults() {
    searchLoading.style.display = 'none';
    searchContent.style.display = 'none';
    searchEmpty.style.display = 'none';
    searchContent.innerHTML = '';
  }

  function showResults(products) {
    searchLoading.style.display = 'none';
    
    if (products.length === 0) {
      searchEmpty.style.display = 'block';
      searchContent.style.display = 'none';
      return;
    }

    searchEmpty.style.display = 'none';
    searchContent.style.display = 'grid';
    
    searchContent.innerHTML = products.map(product => `
      <a href="${product.url}" class="search-result-item">
        <img src="${product.image}" alt="${product.title}" class="search-result-image" loading="lazy">
        <h3 class="search-result-title">${product.title}</h3>
        <p class="search-result-price">${product.price}</p>
      </a>
    `).join('');
  }

  function performSearch(query) {
    const controller = new AbortController();
    currentRequest = controller;

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`, {
      signal: controller.signal
    })
    .then(response => response.json())
    .then(data => {
      const products = data.resources.results.products || [];
      const formattedProducts = products.map(product => ({
        title: product.title,
        url: product.url,
        price: "Rs." + (product.price),
        image: product.image ? product.image.replace('.jpg', '_200x200.jpg').replace('.png', '_200x200.png') : '/assets/placeholder.svg'
      }));
      
      showResults(formattedProducts);
      currentRequest = null;
    })
    .catch(error => {
      if (error.name !== 'AbortError') {
        console.error('Search error:', error);
        hideAllResults();
      }
      currentRequest = null;
    });
  }
});

// Mobile Menu functionality
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');
const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
const mobileMenuClose = document.getElementById('mobile-menu-close');

function openMobileMenu() {
  mobileMenu.classList.add('mobile-menu--active');
  mobileMenuOverlay.classList.add('mobile-menu__overlay--active');
  document.body.style.overflow = 'hidden';
}

function closeMobileMenu() {
  mobileMenu.classList.remove('mobile-menu--active');
  mobileMenuOverlay.classList.remove('mobile-menu__overlay--active');
  document.body.style.overflow = '';
  // Reset to main panel
  setTimeout(() => {
    const panels = mobileMenu.querySelectorAll('.mobile-menu__panel');
    panels.forEach(panel => panel.classList.remove('mobile-menu__panel--active'));
    const mainPanel = mobileMenu.querySelector('[data-panel="main"]');
    if (mainPanel) mainPanel.classList.add('mobile-menu__panel--active');
  }, 300);
}

if (mobileMenuToggle) {
  mobileMenuToggle.addEventListener('click', openMobileMenu);
}

if (mobileMenuClose) {
  mobileMenuClose.addEventListener('click', closeMobileMenu);
}

if (mobileMenuOverlay) {
  mobileMenuOverlay.addEventListener('click', closeMobileMenu);
}

// Mobile menu navigation
const expandableLinks = mobileMenu.querySelectorAll('.mobile-menu__link--expandable');
expandableLinks.forEach(link => {
  link.addEventListener('click', function() {
    const targetPanel = this.getAttribute('data-target');
    const currentPanel = this.closest('.mobile-menu__panel');
    const nextPanel = mobileMenu.querySelector(`[data-panel="${targetPanel}"]`);
    
    if (nextPanel) {
      currentPanel.classList.remove('mobile-menu__panel--active');
      nextPanel.classList.add('mobile-menu__panel--active');
    }
  });
});

// Back buttons
const backButtons = mobileMenu.querySelectorAll('.mobile-menu__back');
backButtons.forEach(button => {
  button.addEventListener('click', function() {
    const targetPanel = this.getAttribute('data-back');
    const currentPanel = this.closest('.mobile-menu__panel');
    const prevPanel = mobileMenu.querySelector(`[data-panel="${targetPanel}"]`);
    
    if (prevPanel) {
      currentPanel.classList.remove('mobile-menu__panel--active');
      prevPanel.classList.add('mobile-menu__panel--active');
    }
  });
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const searchOverlay = document.getElementById('search-overlay');
    if (searchOverlay && searchOverlay.classList.contains('search-overlay--active')) {
      // Search close handled above
    }
    if (mobileMenu && mobileMenu.classList.contains('mobile-menu--active')) {
      closeMobileMenu();
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(element) {
      this.element = element;
      this.slides = Array.from(element.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(element.querySelectorAll('.hero-slider__dot'));
      this.prevButton = element.querySelector('.hero-slider__arrow--prev');
      this.nextButton = element.querySelector('.hero-slider__arrow--next');
      
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplayEnabled = element.dataset.autoplay === 'true';
      this.slideSpeed = parseInt(element.dataset.speed) || 5;
      this.intervalId = null;
      
      this.init();
    }

    init() {
      if (this.totalSlides === 0) return;

      // Show first slide
      this.slides[0].classList.add('hero-slider__slide--active');

      // Set up navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      // Set up dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Start autoplay
      if (this.autoplayEnabled && this.totalSlides > 1) {
        this.startAutoplay();
      }

      // Pause on hover
      this.element.addEventListener('mouseenter', () => this.stopAutoplay());
      this.element.addEventListener('mouseleave', () => {
        if (this.autoplayEnabled && this.totalSlides > 1) {
          this.startAutoplay();
        }
      });
    }

    goToSlide(index) {
      // Remove active class from current slide and dot
      this.slides[this.currentIndex].classList.remove('hero-slider__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('hero-slider__dot--active');
      }

      // Update index
      this.currentIndex = index;

      // Add active class to new slide and dot
      this.slides[this.currentIndex].classList.add('hero-slider__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('hero-slider__dot--active');
      }

      // Reset autoplay
      this.resetAutoplay();
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.totalSlides;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.slideSpeed * 1000);
    }

    stopAutoplay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    resetAutoplay() {
      if (this.autoplayEnabled && this.totalSlides > 1) {
        this.startAutoplay();
      }
    }

    destroy() {
      this.stopAutoplay();
    }
  }

  // Initialize hero slider
  document.addEventListener('DOMContentLoaded', () => {
    const heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) {
      new HeroSlider(heroSlider);
    }
  });

  // Cleanup on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('.hero-slider')) {
      const slider = event.target.querySelector('.hero-slider');
      if (slider && slider.heroSliderInstance) {
        slider.heroSliderInstance.destroy();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('.testimonials-slider__track');
      this.slides = Array.from(element.querySelectorAll('.testimonials-slider__slide'));
      this.dots = Array.from(element.querySelectorAll('.testimonials-slider__dot'));
      
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplayEnabled = element.dataset.autoplay === 'true';
      this.slideSpeed = parseInt(element.dataset.speed) || 5;
      this.intervalId = null;
      this.slidesPerView = this.getSlidesPerView();
      
      this.init();
      this.handleResize();
    }

    getSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 768) return 1;
      if (width <= 1024) return 2;
      return 3;
    }

    getSlidePercentage() {
      const width = window.innerWidth;
      if (width <= 768) return 85; // Show 85% on mobile (15% peek)
      if (width <= 1024) return 50; // Show 50% on tablet
      return 33.333; // Show 33.333% on desktop (3 cards)
    }

    init() {
      if (this.totalSlides === 0) return;

      // Set up dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Start autoplay
      if (this.autoplayEnabled && this.totalSlides > 1) {
        this.startAutoplay();
      }

      // Pause on hover
      this.element.addEventListener('mouseenter', () => this.stopAutoplay());
      this.element.addEventListener('mouseleave', () => {
        if (this.autoplayEnabled && this.totalSlides > 1) {
          this.startAutoplay();
        }
      });
    }

    handleResize() {
      window.addEventListener('resize', () => {
        // Recalculate position on resize
        this.goToSlide(this.currentIndex);
      });
    }

    goToSlide(index) {
      // Calculate max index based on slides per view
      const slidesPerView = this.getSlidesPerView();
      const maxIndex = Math.max(0, this.totalSlides - slidesPerView);
      
      // Allow looping
      if (index > maxIndex) {
        this.currentIndex = 0;
      } else if (index < 0) {
        this.currentIndex = maxIndex;
      } else {
        this.currentIndex = index;
      }

      // Calculate transform based on percentage
      const slidePercentage = this.getSlidePercentage();
      const transform = -(this.currentIndex * slidePercentage);
      this.track.style.transform = `translateX(${transform}%)`;

      // Update dots
      this.dots.forEach((dot, i) => {
        if (i === this.currentIndex) {
          dot.classList.add('testimonials-slider__dot--active');
        } else {
          dot.classList.remove('testimonials-slider__dot--active');
        }
      });

      // Reset autoplay
      this.resetAutoplay();
    }

    nextSlide() {
      const slidesPerView = this.getSlidesPerView();
      const maxIndex = Math.max(0, this.totalSlides - slidesPerView);
      let nextIndex = this.currentIndex + 1;
      
      // Loop back to start
      if (nextIndex > maxIndex) {
        nextIndex = 0;
      }
      
      this.goToSlide(nextIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.slideSpeed * 1000);
    }

    stopAutoplay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    resetAutoplay() {
      if (this.autoplayEnabled && this.totalSlides > 1) {
        this.startAutoplay();
      }
    }

    destroy() {
      this.stopAutoplay();
    }
  }

  // Initialize testimonials slider
  document.addEventListener('DOMContentLoaded', () => {
    const testimonialsSlider = document.querySelector('.testimonials-slider');
    if (testimonialsSlider) {
      new TestimonialsSlider(testimonialsSlider);
    }
  });

  // Cleanup on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('.testimonials-slider')) {
      const slider = event.target.querySelector('.testimonials-slider');
      if (slider && slider.testimonialsSliderInstance) {
        slider.testimonialsSliderInstance.destroy();
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
